import React from "react";

import type { SideNavTheme } from "@performyard/service-contracts";

import { ThemeRadioCell } from "./ThemeRadioCell";

type ThemeRadioListProps = {
	themes: SideNavTheme[];
	selectedThemeId: string;
	onSelect: (themeId: string) => void;
	onEdit: (themeId: string) => void;
	onDelete: (themeId: string) => void;
	canEdit?: boolean;
	disabled?: boolean;
};

export const ThemeRadioList = ({
	themes,
	selectedThemeId,
	onSelect,
	onEdit,
	onDelete,
	canEdit = true,
	disabled = false,
}: ThemeRadioListProps) => (
	<div className="flex flex-wrap gap-2">
		{themes.map((theme) => (
			<ThemeRadioCell
				key={theme.id}
				theme={theme}
				isDefaultPreset={theme.isDefault}
				isSelected={theme.id === selectedThemeId}
				onSelect={onSelect}
				onEdit={theme.isDefault || !canEdit ? undefined : onEdit}
				onDelete={theme.isDefault || !canEdit ? undefined : onDelete}
				disabled={disabled}
			/>
		))}
	</div>
);
